module.exports = __webpack_public_path__ + "img/ve1.91432277.png";